import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const LoginWrapper = styled(Box)`
    width: 100%;
    height: 100vh;
    align-items: center;
    flex-direction: row;
    background-color: #f5e0b5;
`;
